<template>
  <div v-if="reportInfo">
    <table class="form-table type-block--mobile">
      <tbody>
        <!-- 취약점 제목 -->
        <tr>
          <th scope="row">
            Title <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="vulTitle" class="sr-only">Title</label>
            <input
              type="text"
              id="vulTitle"
              placeholder=""
              class="form-table__input"
              v-model="reportInfo.vulTitle"
            />
          </td>
        </tr>
        <!-- 취약점 요약 -->
        <tr>
          <th scope="row">
            Summary <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="vulSummary" class="sr-only">Summary</label>
            <input
              type="text"
              id="vulSummary"
              placeholder=""
              class="form-table__input"
              v-model="reportInfo.vulSummary"
            />
          </td>
        </tr>
        <!-- 제조사 -->
        <tr>
          <th scope="row">
            Manufacturer
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="forcedEntryMakrName" class="sr-only"
              >Manufacturer</label
            >
            <input
              type="text"
              id="forcedEntryMakrName"
              placeholder=""
              class="form-table__input"
              v-model="reportInfo.forcedEntryMakrName"
            />
          </td>
        </tr>
        <!-- 버전 -->
        <tr>
          <th scope="row">
            Version/Build
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="ver" class="sr-only">Version/Build</label>
            <input
              type="text"
              id="ver"
              placeholder=""
              class="form-table__input"
              v-model="reportInfo.ver"
            />
          </td>
        </tr>
        <!-- 취약점 발생환경 -->
        <tr>
          <th scope="row">
            Bug Occurrence Environment
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">Bug Occurrence Environment</label>
            <div>
              <StacksEditor
                v-model="reportInfo.vulEnvironment"
                :id="'vulEnvironment'"
                :system="'report'"
                @htmlchanged="onHtmlChanged"
              />
            </div>
          </td>
        </tr>
        <!-- 취약점 발견방법 -->
        <tr>
          <th scope="row">
            Methods of bug discovery
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">Methods of bug discovery</label>
            <div>
              <StacksEditor
                v-model="reportInfo.vulDetection"
                :id="'vulDetection'"
                :system="'report'"
                @htmlchanged="onHtmlChanged"
              />
            </div>
          </td>
        </tr>
        <!-- 취약점 발생원인 -->
        <tr>
          <th scope="row">
            Cause of bug occurrence
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">Cause of bug occurrence</label>
            <div>
              <StacksEditor
                v-model="reportInfo.vulCause"
                :id="'vulCause'"
                :system="'report'"
                @htmlchanged="onHtmlChanged"
              />
            </div>
          </td>
        </tr>
        <!-- 취약점 증명/검증 -->
        <tr>
          <th scope="row">
            Proof-of-concept and exploit code
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">Proof-of-concept and exploit code</label>
            <div>
              <StacksEditor
                v-model="reportInfo.vulVerify"
                :id="'vulVerify'"
                :system="'report'"
                @htmlchanged="onHtmlChanged"
              />
            </div>
          </td>
        </tr>
        <!-- 취약점 악용 시나리오 -->
        <tr>
          <th scope="row">
            Exploitation Scenarios
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">Exploitation Scenarios</label>
            <div>
              <StacksEditor
                v-model="reportInfo.vulScript"
                :id="'vulScript'"
                :system="'report'"
                @htmlchanged="onHtmlChanged"
              />
            </div>
          </td>
        </tr>
        <!-- 취약점 조치방안 -->
        <tr>
          <th scope="row">
            Bug fixing method (mitigation)
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">Bug fixing method (mitigation)</label>
            <div>
              <StacksEditor
                v-model="reportInfo.vulAction"
                :id="'vulAction'"
                :system="'report'"
                @htmlchanged="onHtmlChanged"
              />
            </div>
          </td>
        </tr>
        <!-- 취약점 기타 -->
        <tr>
          <th scope="row">Other information related to the bug</th>
          <td>
            <label class="sr-only">Other information related to the bug</label>
            <input
              type="text"
              id="vulEtc"
              placeholder=""
              class="form-table__input"
              v-model="reportInfo.vulEtc"
            />
          </td>
        </tr>
        <!-- 첨부파일 -->
        <tr>
          <th scope="row">Upload file</th>
          <td>
            <FileUpload
              :max-size="30"
              :allow-ext="allowExt"
              language="en"
              @add="handleFileAdd"
            ></FileUpload>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import reportHandler from "../../ReportHandler.js";
import { ref, watch, inject } from "vue";
import FileUpload from "@/component/FileUpload.vue";
import StacksEditor from "@/editor/StacksEditor.vue";

export default {
  name: "VulInfo",
  components: { StacksEditor, FileUpload },
  props: {
    modelValue: { type: Object, required: true },
  },
  setup(props, { emit }) {
    const lodash = inject("lodash");

    // data 정의
    const allowExt = ref(reportHandler.getAllowAttachFileExt());
    const reportInfo = ref(lodash.cloneDeep(props.modelValue.reportInfo));
    const uploadFile = ref(props.modelValue.uploadFile);

    // methods 정의

    const handleFileAdd = (addedFiles) => {
      // FileUpload 컴포넌트에서 전달받은 파일 목록 처리
      const file = addedFiles.length > 0 ? addedFiles[0] : null;
      uploadFile.value = file;
    };
    const onHtmlChanged = ({ id, html }) => {
      if (id === "vulEnvironment") {
        reportInfo.value.vulEnvironmentHtml = html;
      } else if (id === "vulDetection") {
        reportInfo.value.vulDetectionHtml = html;
      } else if (id === "vulCause") {
        reportInfo.value.vulCauseHtml = html;
      } else if (id === "vulVerify") {
        reportInfo.value.vulVerifyHtml = html;
      } else if (id === "vulScript") {
        reportInfo.value.vulScriptHtml = html;
      } else if (id === "vulAction") {
        reportInfo.value.vulActionHtml = html;
      }
    };

    // watch 정의
    watch(
      reportInfo,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          reportInfo: newVal,
        });
      },
      { deep: true }
    );

    watch(
      uploadFile,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          uploadFile: newVal,
        });
      },
      { deep: true }
    );
    // html에서 사용될 데이터 정의
    return {
      reportInfo,
      allowExt,
      handleFileAdd,
      onHtmlChanged,
    };
  },
};
</script>

<style>
</style>